import React, { useEffect } from "react";
import { RouterProvider } from "react-router-dom";
import { ThemeProvider, useTheme } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import { Toaster } from "react-hot-toast";
import theme from "./theme/theme";
import { HeaderActionsProvider } from "./contexts/HeaderActionsContext";
import router from "./router";
import apiContextHelper from "./composables/apiContextHelper";
import { useAppDispatch } from "./store/hooks";

const ToastConfig: React.FC = () => {
  const muiTheme = useTheme();

  return (
    <Toaster
      position="top-right"
      toastOptions={{
        duration: 4000,
        style: {
          background: muiTheme.palette.background.paper,
          color: muiTheme.palette.text.primary,
          borderRadius: muiTheme.shape.borderRadius,
          boxShadow: muiTheme.shadows[4],
        },
        success: {
          iconTheme: {
            primary: muiTheme.palette.success.main,
            secondary: muiTheme.palette.background.paper,
          },
        },
        error: {
          iconTheme: {
            primary: muiTheme.palette.error.main,
            secondary: muiTheme.palette.background.paper,
          },
        },
      }}
    />
  );
};

const App: React.FC = () => {
  const { setDispatch } = apiContextHelper();
  const dispatch = useAppDispatch();
  useEffect(() => {
    setDispatch(dispatch);
  }, [dispatch]);
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <HeaderActionsProvider>
        <RouterProvider router={router} />
      </HeaderActionsProvider>
      <ToastConfig />
    </ThemeProvider>
  );
};

export default App;
